import { instance } from '../../util/http'
import apis from '../../config/apis'
// 获取立即购买的订单接口
const get = (data) => {
    return instance.post(apis.Checkout.Get,data)
}
// lhy 新增 获取订单商品
const getShareList = (data)=>{
    return instance.post(apis.Checkout.Get,data)
}
const GetCheckOutPage = () => {
    return instance.get(apis.Checkout.GetCheckOutPage)
}

const getBasketCheckout = () => {
    return instance.post(apis.Checkout.GetBasketCheckout)
 }

const post = (data) => {
    return instance.post(apis.Checkout.post, {
        skuId: data.skuId,
        goodsId: data.goodsId,
        quantity: data.quantity,
        userCouponId: data.userCouponId,
        addressId: data.addressId
    })
}
// 默认地址
const getDefault = () => {
    return instance.get(apis.Address.getDefault)
}
// 获取优惠卷
const getCoupons = (userCouponStatusId, page, limit) => {
    return instance.get(apis.Coupons.checkoutGet + "?userCouponStatusId=" + userCouponStatusId + "&page=" + page + "&limit=" + limit)
}

//获取用户默认优惠券
const getDefaultCoupon = (couponCode) => {
    return instance.get(apis.Checkout.GetDefaultCoupon + "/" + couponCode);
}
//获取用户优惠券价格
const getCouponPrice = (couponCode, goodsCode, skuCode) => {
    return instance.get(apis.Checkout.GetCouponPrice + "?" + "couponCode=" + couponCode + "&goodsCode=" + goodsCode + "&skuCode=" + skuCode)
}

// const getCartCouponPrice = (couponCode) => {
//     return instance.get(apis.Checkout.getCouponPrice + "?" + "couponCode=" + couponCode)
// }
// 原有立即购买
const purchase = (data) => {
    return instance.post(apis.Checkout.purchase, data)
}
// lhy 新增分享立即购买
const shareBuyShop = (data) => {
    return instance.post(apis.Checkout.shopShare, data)
}
// 购物车购买
const purchaseCart = (data) => {
    return instance.post(apis.Checkout.purchaseCart, data)
}
// 缺少订单详情页面

// 获取限购商品详情
const GetLimitGoodsDetail = (data) => {
    return instance.post(apis.Goods.GetLimitGoodsDetail,data)
}

// 是否有活动
const GetActive = () => {
    return instance.get(apis.Checkout.GetActiveText)
}


export default {
    get,
    GetCheckOutPage,
    post,
    getDefault,
    getCoupons,
    purchase,
    purchaseCart,
    getDefaultCoupon,
    getCouponPrice,
    // getCartCouponPrice,
    getBasketCheckout,
    GetLimitGoodsDetail,
    GetActive,
    getShareList,
    shareBuyShop
}